// The "live-status" API expander (asaj.site), sent with every page
export function getLiveStatus(content) {
  return content?.['@components']?.['live-status'] ?? null;
}

export function isLive(content) {
  return (getLiveStatus(content)?.live?.length ?? 0) > 0;
}

// "Fri 23 Oct", in Jamaica time whatever the reader's time zone
export function formatMeetDay(iso) {
  if (!iso) return '';
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'America/Jamaica',
  }).format(new Date(iso));
}
